import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'


import favicon from '../static/favicons/favicon.ico'

import './index.css'

import MobNav from '../components/MobNav';
import DeskNav from '../components/deskNav';
import WindowDimensions from '../components/windowDimensions';

class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: '0',
      height: '0',
      currentPath: ''
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    if (window) {
        window.addEventListener('resize', this.updateWindowDimensions);
    }
  }

  componentWillUnmount() {
      if (window) {
          window.removeEventListener('resize', this.updateWindowDimensions);
      }
  }

  updateWindowDimensions = () => {
      if (window) {
          this.setState({
              width: window.innerWidth,
              height: window.innerHeight
          });
      }
  };

  render() {
    return (
      <div className="row">
        <Helmet
          title={this.props.data.site.siteMetadata.title}
          meta={[
            { name: 'title', content: 'Daresay News'},
            { name: 'description', content: '' },
          ]}>
          {/* Schema.org for Google */}
          <meta charset="UTF-8" />
          <meta itemprop="name" content="Daresay News" />
          <meta itemprop="description" content="" />
          <meta itemprop="image" content="" />
          {/* Twitter */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Daresay News" />
          <meta name="twitter:description" content="" />
          {/* Og general - Facebook, Pinterest and Google plus */}
          <meta property="og:title" content="Daresay News" />
          <meta property="og:description" content="" />
          <meta property="og:image:url" content="" />
          <meta property="og:url" content="" />
          <meta property="og:site_name" content="" />
          <meta property="og:type" content="website" />

          <link rel="icon" type="image/png" sizes="16x16" href={favicon}/>

          <link href="https://fonts.googleapis.com/css?family=Libre+Franklin:300,600|Space+Mono:700" rel="stylesheet" />

          {/* <link rel="mask-icon" href={safariPinned} color="#000000"/> */}
          <meta name="msapplication-TileColor" content="#000000"/>
          <meta name="theme-color" content="#ffffff"/>
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          </Helmet>
        {this.state.width < 800 ?
          <MobNav />
          :
          <DeskNav />}
          <div className="mainContent col">
            {this.props.children()}
          </div>
      </div>
    )
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js